export const MobileMultiSelectConstants = {
    moreCTA: 'more',
    clearAllCTA: 'Clear All',
    applyCTA: 'Apply',
    selectedMessage: 'selected',
    allSelected: 'All',
};

export const AllOption = {
    value: 'all',
    label: 'All',
    id: 'all',
};
